import styled from 'styled-components';

export const UiAccountEditPage = styled.div`
	display: block;
`;